import { gql } from "@apollo/client";

export const GET_ALIMENTACION_ENTERAL_CONTRATO = gql`
    query AlimentacionEnteralRIByDatosGeneralesId (
        $idDatosGenerales: Int!
    ) {
        alimentacionEnteralRIByDatosGeneralesId (
            idDatosGenerales: $idDatosGenerales
        ){
            idAlimentacionEnteralRI
            idComboRIValorTipoAccesoAE
            cambioSNGdomicilio
        }
    }
`;

export const adaptAlimentacionEnteralContrato = ({ alimentacionEnteralRIByDatosGeneralesId }) => {
  return {
    idAlimentacionEnteralRI: alimentacionEnteralRIByDatosGeneralesId?.idAlimentacionEnteralRI,
    idComboRIValorTipoAcceso: alimentacionEnteralRIByDatosGeneralesId?.idComboRIValorTipoAccesoAE,
    cambioSNGdomicilio: alimentacionEnteralRIByDatosGeneralesId?.cambioSNGdomicilio
  };
};